import { useSite, usePageSeo } from "@/context/SiteContext";
import { resolveImageUrl } from "@/lib/api";

export default function AboutPage() {
  const { content } = useSite();
  const page = content.page_about || {};
  usePageSeo(page.seo_title || "About Us", page.seo_description || page.hero_description);

  return (
    <div className="min-h-screen bg-background" data-testid="about-page">
      <div className="bg-zinc-950 border-b border-zinc-800 py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-white">
            {page.hero_title || "About Us"}
          </h1>
          {page.hero_description && (
            <p className="text-zinc-400 mt-3 max-w-2xl">{page.hero_description}</p>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 space-y-16">
        {(page.body_sections || []).map((s, i) => (
          <div
            key={s.id || i}
            className={`grid grid-cols-1 ${s.image ? "lg:grid-cols-2" : ""} gap-10 items-center`}
            data-testid={`about-section-${i}`}
          >
            <div className={i % 2 === 1 && s.image ? "lg:order-2" : ""}>
              <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase text-foreground mb-4">{s.heading}</h2>
              <p className="text-zinc-400 leading-relaxed whitespace-pre-line">{s.text}</p>
            </div>
            {s.image && (
              <img
                src={resolveImageUrl(s.image)}
                alt={s.heading}
                className="border border-[#262626] w-full aspect-[16/10] object-cover"
                loading="lazy"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
